var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipsisHorizontalCircle = function SvgEllipsisHorizontalCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.188 10a.312.312 0 1 1-.625 0 .312.312 0 0 1 .625 0m0 0h-.313m3.438 0a.312.312 0 1 1-.625 0 .312.312 0 0 1 .624 0m0 0H10m3.438 0a.312.312 0 1 1-.625 0 .312.312 0 0 1 .624 0m0 0h-.313m4.375 0a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0"
  })));
};
export { SvgEllipsisHorizontalCircle as ReactComponent };
export default __webpack_public_path__ + "2b2155b0f1038b412372ccdf73cc27cb.svg";